<script>
  import { onMount, createEventDispatcher } from 'svelte';
  import { push } from 'svelte-spa-router';

  let loggedInUser = null;
  const dispatch = createEventDispatcher();

  onMount(() => {
    const savedUser = localStorage.getItem('loggedInUser');
    if (savedUser) {
      loggedInUser = JSON.parse(savedUser);
    }
  });

  function handleLogout() {
    fetch('/api/users/logout', { method: 'POST' })
      .then(() => {
        localStorage.removeItem('loggedInUser');
        push('/login'); // 부드럽게 페이지 이동
      });
  }

  function goAccountManage() {
    push('/accountmanage');
  }
</script>

<nav>
  <div class="nav-left">
    <div class="logo-container">
      <img src="../images/sndlogo2.png" alt="logo" class="logo-image"/>    
    </div>
  </div>

  <div class="nav-right">
    {#if loggedInUser}
      <span class="user-info">
        <i class="bi bi-person-fill"></i>{loggedInUser.id} ({loggedInUser.department})
      </span>

      <!-- ✅ Admin 계정만 계정관리 버튼 노출 -->
      {#if loggedInUser.role === 'admin'}
        <button on:click={goAccountManage} title="계정관리">
          계정관리
        </button>
      {/if}

      <button on:click={handleLogout} title="Logout">
        <i class="bi bi-box-arrow-right"></i>
      </button>
    {:else}
      <span class="user-info">로그인이 필요한 페이지입니다.</span>
    {/if}
  </div>
</nav>

<style>
  nav {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    height: 60px;
    background-color: #fafaf6;
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #212529;
    border-bottom: 1px solid #ddd;
  }
  .nav-left {
    font-size: 1.4rem;
    font-weight: bold;
    color: #5e5e4a;
  }
  
  .logo-image {
    width: 60px;
    height: auto;
    margin-bottom: 5px;
  }

  .nav-right {
    display: flex;
    align-items: center;
    gap: 16px;
    font-size: 0.95rem;
  }
  .user-info {
    color: #333;
    font-weight: 500;
  }
  .bi-person-fill {
    font-size: 1.25rem;
    color: #92927b;
  }
  .bi-box-arrow-right {
    color: #5e5e4a;
  }
  button {
    padding: 6px 14px;
    background-color: #f5f5ea;
    border: 1px solid #5e5e4a;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.9rem;
    transition: background-color 0.2s ease-in-out;
    color: #333;
  }
  button:hover {
    background-color: #cfcfca;
  }
</style>
